<script>
  import { location } from 'svelte-spa-router'
  import narrative from '../data/narrative.json'
  import Menu from '../components/Menu.svelte'
</script>

<header>
  <div class="logo">
    <a href="https://theoutlier.co.za"
      ><img src="/images/outlier-logo-200.png" alt="Outlier" /></a
    >
  </div>

  {#if $location === '/'}
    <div class="masthead">
      <Menu />
      <div class="spacer">&nbsp;</div>
      RIOT
      <div class="subhead">
        Eight days of protests and looting that shook South Africa
      </div>
      <div class="introduction">
        {narrative.introduction}
      </div>
    </div>
  {/if}
</header>

{#if $location === '/'}
  <div class="background-video-intro">
    <video
      autoplay
      muted
      loop
      poster="/images/drone-poster-opt.jpg"
      id="bgVideo"
    >
      <source
        src="https://hosted.mediahack.co.za/looting/video/drone-final.mp4"
        type="video/mp4"
      />
    </video>
  </div>
{/if}

<style>
  .spacer {
    margin-bottom: 20px;
  }
  .logo {
    width: 100%;
    background: #000;
    padding-top: 10px;
    padding-bottom: 5px;
  }

  #bgVideo {
    position: fixed;
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 100%;
    z-index: -100;
  }

  header {
    width: 100%;
    text-align: center;
  }
  .masthead {
    background-image: linear-gradient(
      rgba(126, 0, 63, 100),
      rgba(126, 0, 63, 50),
      rgba(0, 0, 0, 0)
    );

    font-size: 10rem;
    /* font-family: var(--titleFont); */
    font-family: 'Roboto Slab', sans;
    padding-top: 0px;
    padding-bottom: 40px;
    font-weight: 900;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    line-height: 9rem;
    margin-top: 0px;
    /* padding: 100px; */
    padding-bottom: 10px;
  }
  .subhead {
    font-family: 'Roboto Slab', sans;
    font-size: 2rem;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    line-height: 2.5rem;
    margin-top: 50px;
  }
  .background-video-intro {
    max-width: 90%;
  }

  @media only screen and (max-width: 600px) {
    .subhead {
      max-width: 90%;
    }
    .introduction {
      max-width: 90%;
    }
    .background-video-intro {
      max-width: 90%;
    }
  }
</style>
